import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const KEY = 'dca_portal_theme';
const PortalThemeContext = createContext({ theme: 'light', setTheme: () => {}, toggleTheme: () => {} });

export function PortalThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try { return localStorage.getItem(KEY) || 'light'; } catch { return 'light'; }
  });

  const setTheme = useCallback((t) => {
    setThemeState(t);
    try { localStorage.setItem(KEY, t); } catch { /* ignore */ }
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  }, [theme, setTheme]);

  useEffect(() => {
    try { localStorage.setItem(KEY, theme); } catch { /* ignore */ }
  }, [theme]);

  return (
    <PortalThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </PortalThemeContext.Provider>
  );
}

export const usePortalTheme = () => useContext(PortalThemeContext);
export default PortalThemeContext;
